import React from "react";
import "./Header.css";
import logo from "../assets/logo.png";

function Header() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <span>10% OFF YOUR FIRST TREATMENT</span>
        <span>•</span>
        <span>FREE NO-OBLIGATION CONSULTATIONS</span>
        <span>•</span>
        <span>MILTON KEYNES</span>
      </div>

      {/* Main Header */}
      <header className="header">
        {/* Logo Image */}
        <div className="logo">
          <img src={logo} alt="Rejuvenate Aesthetics & Skincare" />
        </div>

        {/* Navigation Links */}
        <nav className="navbar">
          <a href="#home">HOME</a>
          <a href="#treatments">TREATMENT</a>
          <a href="#offers">SPECIAL OFFERS</a>
          <a href="#results">RESULTS</a>
          <a href="#reviews">REVIEWS</a>
          <a href="#contact">CONTACT</a>
          <a href="#about">ABOUT</a>
        </nav>

        {/* Call & Book Section */}
        <div className="header-right">
          <a href="tel:07802484141" className="phone-link">
            📞 07802 484141
          </a>
          <button 
            className="book-btn" 
            onClick={() => scrollToSection("contact")}
          >
            BOOK CONSULTATION
          </button>
        </div>
      </header>
    </>
  );
}

export default Header;